<template>
  <div id="OrgRegisterList">
    <eb-header>
      <eb-break-crumb slot='breakCrumb' />
      <eb-search
        @search-click='loadOrgRegisterDataBySearchWord'
        slot='search'
      />
    </eb-header>
    <div class="box-header">
      <div class="box-header-right">
        <el-button
          :disabled="isDelStatus"
          @click="deleteDepart"
          class="eb-button-red eb-button-small"
        >删除</el-button>
      </div>
    </div>
    <div class="table-box">
      <div class="eb-table">
        <el-table
          :data="pageData.orgRegisterList"
          :stripe="true"
          row-key="departRegisterId"
          @selection-change="handleSelectionChange"
          ref="pushListRef"
          style="width: 100%"
        >
          <el-table-column
            :reserve-selection="true"
            type="selection"
            width="40"
          ></el-table-column>
          <el-table-column
            sortable
            prop="departName"
            label="机构名称"
          >
            <template slot-scope="scope">
              <a
                @click="showDepartInfo(scope.row.departRegisterId)"
                href="javascript:void(0)"
                class="a-font-red "
              >{{scope.row.departName}}</a>
            </template>
          </el-table-column>
          <el-table-column
            sortable
            prop="trueName"
            label="管理员姓名"
            width="120"
          ></el-table-column>
          <el-table-column
            sortable
            prop="userPhone"
            label="电话"
            width="120"
          ></el-table-column>
          <el-table-column
            sortable
            prop="userEmail"
            label="邮件"
            width="100"
          ></el-table-column>
          <el-table-column
            sortable
            prop="departType"
            label="机构权限"
            width="100"
          >
            <template slot-scope='scope'>
              {{scope.row.departType|orgType}}
            </template>
          </el-table-column>
          <el-table-column
            sortable
            prop="registerStauts"
            label="状态"
            width="80"
          >
            <template slot-scope='scope'>
              {{scope.row.registerStauts|registerStauts}}
            </template>
          </el-table-column>
          <el-table-column
            sortable
            prop="registerTime"
            label="首次申请时间"
            width="130"
          >
            <template slot-scope='scope'>
              {{scope.row.registerTime|dateTimeStandardFormat}}
            </template>
          </el-table-column>
          <el-table-column
            prop="updateTime"
            label="修改提交时间"
            width="120"
          >
            <template slot-scope='scope'>
              {{scope.row.updateTime|dateTimeStandardFormat}}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <eb-pagination
      class="pagination"
      :current-page.sync="searchParams.start"
      v-if="searchParams.length"
      @current-change="onPageChange"
      :total="pageData.recordsTotal"
    />
    <OrgRegisterDialog
      @registerSuccess="registerSuccess"
      :isVisible.sync='dialogVisible'
      :orgRegisterInfo='orgRegisterInfo'
    />
  </div>
</template>
<script>
import ebHeader from '@/components/common/eb-header';
import ebBreakCrumb from '@/components/common/eb-break-crumb';
import ebSearch from '@/components/common/eb-search';
import EbPagination from '@/components/common/eb-pagination/eb-pagination';
import OrgRegisterDialog from '@/components/org/register/OrgRegistertDialog';
import { listOrgRegister, delRegisterOrg } from '@/services/org/depart-register-service';
import { clone } from 'lodash';
export default {
  components: {
    ebHeader,
    ebBreakCrumb,
    ebSearch,
    EbPagination,
    OrgRegisterDialog
  },
  data() {
    return {
      initSearchParams: {
        length: 10,
        start: 1
      },
      searchParams: null,
      pageData: {
        orgRegisterList: [],
        recordsTotal: 0
      },
      isDelStatus: true,
      departRegisterIds: [],
      dialogVisible: false,
      orgRegisterInfo: {
        returnEditBtnStatus: true,
        auditedRegisterBtnStatus: true,
        auditOpinionStatus: true
      }
    };
  },
  computed: {
    paginationSize() {
      return this.pageData.recordsTotal / this.searchParams.length;
    }
  },
  created() {
    this.searchParams = clone(this.initSearchParams);
    this.loadOrgRegisterData();
  },
  methods: {
    // 搜索操作
    loadOrgRegisterDataBySearchWord(text) {
      this.searchParams.searchContent = text;
      this.loadOrgRegisterData();
    },
    // 当前页改变操作
    onPageChange(pageNum) {
      this.searchParams.start = pageNum;
      this.loadOrgRegisterData();
    },
    async loadOrgRegisterData() {
      this.$root.layout.isLoading = true;
      try {
        let { data } = await listOrgRegister(this.searchParams);
        this.pageData.recordsTotal = data.recordsTotal;
        this.pageData.orgRegisterList = data.data || [];
      } catch (error) {
        this.$message.error('加载注册列表失败');
      }
      this.$root.layout.isLoading = false;
    },
    handleSelectionChange: function(rows) {
      this.departRegisterIds = [];
      this.isDelStatus = true;
      if (rows.length > 0) {
        this.isDelStatus = false;
        rows.forEach(element => {
          this.departRegisterIds.push(element.departRegisterId);
        });
      }
    },
    // 点击名称显示注册内容
    async showDepartInfo(departRegisterId) {
      this.$router.push('/org/register/audit/' + departRegisterId);
    },
    // 删除
    deleteDepart() {
      this.$ebConfirm('确认删除？').then(async result => {
        this.$root.layout.isLoading = true;
        try {
          if (this.departRegisterIds.length > 0) {
            try {
              let departRegisterIds = this.departRegisterIds.join(',');
              let { data } = await delRegisterOrg(departRegisterIds);
              if (data.returnCode === '01') {
                this.loadOrgRegisterData();
                this.departRegisterIds = [];
                this.isDelStatus = true;
                this.$message.success('删除成功');
              }
            } catch (error) {
              this.$message.error('删除失败');
            }
          } else {
            this.$message.error('请选择要删除的机构');
          }
        } catch (error) {
          this.$message.error('删除失败');
        }
        this.$root.layout.isLoading = false;
      });
    },
    registerSuccess: function() {
      this.loadOrgRegisterData();
    }
  }
};
</script>

<style  scoped lang='less'>
#OrgRegisterList {
  .button-group {
    display: flex;
    justify-content: flex-end;
    padding-right: 47px;
    padding-top: 30px;
  }
  .a-font-red {
    color: red;
    text-decoration: underline !important;
  }
}
</style>
